<template>
  <div id="app" v-if="isReady">
    <navbar-e v-if="hasRegister" :userInfo="userInfo" :type="($agency.isHQHotel || $agency.isHotel) ? 'IRS' : 'HQ'" activeMenu="crm"/>
    <NavBar v-else/>
    <iframe src="/account-web/empty.html" frameborder="0" width="100%" height="660" v-if="!hasPermission"></iframe>

    <div class="body-content" v-else>
      <SideNav :menus="menus"/>
      <BreadCrumb/>
      <div v-if="visible" class="fixWrapperBox">
        <div >
          <div class="boxHeader">
            <span class="important">温馨提示</span>
          </div>
          <div class="havpv-incorrect-wrapper">
            <p v-if="count">尊敬的商户：您好，有<a href="javascript:void(0);" @click="exportHotel"> {{count}} </a>家门店还未登录收银POS，您暂时不能使用会员营销模块。请门店先安装并登录收银POS。</p>
            <p v-else>尊敬的商户：您好，您还未登录收银POS，暂时不能使用会员营销模块。请先安装并登录收银POS。</p>
            <div style="text-align:center;margin:15px 0 0">
              <el-button @click="download" type="primary">下载安装</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="PVIncorrect && !$agency.isHQ">
        <div class="pv-incorrect-wrapper">
          <p class="important">重要提示：</p>
          <p>您门店的收银POS版本与云后台不一致，请登录官网下载CRM专用安装包。</p>
          <p>请点击链接：<a href="http://www.passiontec.cn/passiontec-official/windows" target="_blank">http://www.passiontec.cn/passiontec-official/windows</a>，在windows版下载中选择CRM版本。</p>
          <p>如有问题，请拨打客服电话：400-060-0809</p>
        </div>
      </div>
      <div class="content-wrapper">
        <MessageNav/>
        <div class="app-content">
          <div class="content-inner-wrapper">
            <keep-alive :include="componentName">
              <router-view ></router-view>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import menus from '@constants/menu.js';
  import NavBar from './components/ui/NavBar/NavBar.vue';
  import BreadCrumb from './components/ui/BreadCrumb/BreadCrumb.vue';
  import SideNav from './components/ui/SideNav/SideNav.vue';
  import MessageNav from './components/ui/MessageNav/MessageNav.vue';

  import {mapActions} from 'vuex';

  export default {
    components: {
      NavBar,
      BreadCrumb,
      SideNav,
      MessageNav
    },
    data () {
      return {
        menus: [],
        componentName: ['memberList', 'storeSettlement'],
        showSys: true,
        isReady: false,
        hasPermission: localStorage.menuList && JSON.parse(localStorage.menuList).crm,
        PVIncorrect: false,
        hasRegister: window._hasRegister,
        visible:false,
        tip:'',
        queryData:'',
        count:''
      };
    },
    created () {
      this.removelocalCache(); // 去除机构数据缓存，防止机构数据错乱问题
      let PV = document.cookie.replace(/^.*PV=([\d\."]+).*$/, '$1');
      this.PVIncorrect = !(PV.startsWith('2.27.8') || PV.startsWith('2.27.4') || PV === '""' || PV >= '2.28.80');
      this.$axios.get('/hq-agency/user/current').then(res => {
        if (res.code === 200) {
          this.$store.commit('setUserInfo', res.data);
          this.userInfo = res.data;
          this.$agency.isHQ = (res.data.type === 1 || res.data.type === 2); // 是否为总部/分公司
          this.$agency.isHQHotel = res.data.type === 3; // 是否为连锁门店
          this.$agency.isHotel = res.data.type === 6; // 是否为单店
          this.$agency.hotelId = res.data.hotelId;
          this.getPV();
          this.checkSplitStatus(this.userInfo);
        }
        if (this.$agency.isHQHotel || this.$agency.isHotel) {
          // 如果是单店或连锁门店，先获取结算时间。
          this.getCutOffTimeList().then(() => {
            this.getMenuList();
          }).catch(() => {
            this.getMenuList();
          });
        } else {
          this.getMenuList();
        }
      });
      this.filterFullChannelMenu();
    },
    methods: {
      ...mapActions(['getCutOffTimeList']),
      checkSplitStatus (userInfo) {
        if (window.location.host !== 'e.passiontec.cn') {
          return ;
        }
        const {agencyId, hotelId} = userInfo;
        window.LXAnalytics && window.LXAnalytics('pageView', null, null, "c_eco_ivef2l9z");
        this.$axios.get('/crm-api/eos-api-web/split/check-split', {
          params: {
            agencyId,
            hotelId
          }
        }).then(res => {
          if (!/crm-3=Y/.test(document.cookie) && res.data) {
            document.cookie ='crm-3=Y; expires=Fri, 3 Aug 2049 20:47:11 UTC; path=/';
            window.LXAnalytics && window.LXAnalytics('moduleView',
              // valBid string moduleView 命令发送的统计数据中，事件体 val_bid 字段的值
              'b_eco_4ax8rpff_mv',
              //valLab object	moduleView 命令发送的统计数据中，事件体 val_lab 字段的值
              null,
              // 配置选项
              {
                // 指定本次埋点上报的cid值，后续上报不受此值影响
                cid: 'c_eco_ivef2l9z',
                // 指定本次埋点上报的延迟时间,单位是秒。
                // 在此时间内发送的带有delay参数的其它MV事件，都会被合并入缓存，并在该时间后合并上报。
                // 发送多个delay值不同的MV时，会在最小的delay值后发送，并且不会导致数据重复上报
                // delay: '如有设置您的delay值'
              }
            );
          }
        }).catch(err => {
          console.log(err);
        });
      },
      getPV () {
        if (!this.$agency.isHotel) {
          let agencyId = {agencyId : this.$store.state.userInfo.agencyId};
          this.queryData = `?${this.$qs.stringify(agencyId)}`;
        } else {
          let agencyId = {};
          this.queryData = '';
        }
        this.$axios.get(`/crm-api/eos-api-web/member/checkPosVension${this.queryData}`).then((res) => {
          if (res.code === 200) {
            this.$store.commit('setPVCheck', res.data);
          } else if (res.code === 20023) {
            this.visible = false;
            this.tip = res.message;
            if (res.data) {
              this.count = res.data;
            }
          }
        });
      },
      removelocalCache () {
        localStorage.removeItem('agency_tree');
      },
      async filterFullChannelMenu () {
        let isGray = false;
        let bindStatus = false;
        let isOrdered = false;
        try {
          const res = await this.$axios.get('/crm-api/eos-api-web/allchannel/manage/split/status');
          // status: 1 => 灰度，2 => 非灰度
          if (res.data.status === 1) {
            isGray = true;
          }
        } catch (e) {
          isGray = false;
        }

        // 全渠道 2.0 开通前后须过滤菜单，1.0 则不需要
        if (isGray) {
          try {
            const res2 = await this.$axios.get('/crm-api/eos-api-web/allchannel/manage/poiInfo');
            // poiInfo.opened: true => 已开通 false => 未开通
            if (res2.data && res2.data.poiInfo.opened) {
              this.$store.commit('setPoiInfo', res2.data.poiInfo);
              bindStatus = true;
            }
          } catch (e) {
            bindStatus = false;
          }
        }

        try {
          const res3 = await this.$axios.get('/hq-agency/agency/selectAgencyInfoByHotelIdHead');
          // fullChannel: 1 => 已上单，0 => 未上单
          if (res3.data.fullChannel === 1) {
            isOrdered = true;
          }
        } catch (e) {
          isOrdered = false;
        }

        this.menus = menus.filter(item => {
          if (+item.id === 180) {
            if (isGray) {
              // 仅返回 全渠道2.0 相关菜单
              item.children = item.children.filter(child => {
                return child.id.startsWith('1802');
              });
            } else {
              // 仅返回 全渠道1.0 相关菜单
              item.children = item.children.filter(child => {
                return child.id.startsWith('1801');
              });
            }

            if (isGray && bindStatus) {
              // 2.0 且已开通 拦截 业务开通菜单
              item.children = item.children.filter(child => {
                return child.id.endsWith('2');
              });
            } else if (isGray) {
              // 2.0 且未开通 只返回 业务开通菜单
              item.children = item.children.filter(child => {
                return !child.id.endsWith('2');
              });
            }

            if (isOrdered) {
              item.children = item.children.filter(child => {
                return !child.id.endsWith('0');
              });
            } else {
              item.children = item.children.filter(child => {
                return !child.id.endsWith('1');
              });
            }
          }
          return item;
        });
      },
      download () {
        window.open("http://www.passiontec.cn");
      },
      exportHotel () {
        window.open(`/crm-api/eos-batch/hotel/export${this.queryData}`);
      },
      getMenuList () {
        if (!localStorage.getItem('menuList')) {
          this.$axios.get('/hq-agency/user/menu').then((menu) => {
            if (menu.code === 200) {
              let menuList = {};
              menu.data.forEach(item => {
                menuList[item.systemCode] = item.menu.map((one) => {
                  return one.id;
                });
              });
              localStorage.setItem('menuList', JSON.stringify(menuList));

              this.hasPermission = JSON.parse(localStorage.menuList).crm;
              this.isReady = true;
            }
          });
        } else {
          this.isReady = true;
        }
      }
    }
  };
</script>

<style lang="less">
  body {
    margin: 0 auto;
    overflow-x: hidden;
  }
  .body-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 60px;
  }

  .content-wrapper {
    position: absolute;
    background: #ececec !important;
    top: 0;
    left: 200px;
    right: 0;
    bottom: 0;
    border-left: 1px solid #DCDCDC;
    overflow-x: auto;
    margin-top: 40px; // 面包屑固定定位，内容区空出40px的上边距
    .app-content {
      width: 100%;
      min-width: 1080px;
      z-index: 1;
      .content-inner-wrapper {
        margin: 10px;
      }
    }
  }
  .boxHeader {
    width: 560px;
    margin: 0 auto ;
    position: relative;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    border-bottom: 1px solid #dcdcdc;
    top:190px;
    span {
      font-size: 16px;
    }
  }
  .fixWrapperBox {
    position: fixed;
    z-index: 1999;
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.5);
  }
  .havpv-incorrect-wrapper {
    border-radius: 2px;
    width: 400px;
    padding: 80px 100px 40px;
    background: #FFF;
    margin: 150px auto 0;
    p {
      font-size: 14px;
      line-height: 28px;
    }
    a {
      color: #016cdf;
    }
  }
  .pv-incorrect-wrapper {
    width: 700px;
    padding: 80px 100px;
    background: #F8F8F8;
    margin: 150px auto 0;
    p {
      font-size: 14px;
      line-height: 28px;
    }
    a {
      color: #016cdf;
    }
    .important {
      font-size: 17px;
      font-weight: bold;
      line-height: 34px;
      margin-bottom: 12px;
    }
  }

  .el-breadcrumb {
    position: absolute;
    top: 0;
    right: 0;
    left: 200px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
    z-index: 1;
  }

  /*侧边栏收起*/
  @media screen and (max-width: 1279px) {
    @navWidth: 60px;
    .sidenav {
      width: @navWidth;
      overflow: visible;
      .el-menu {
        border: 1px solid #ccc;
      }
      .menu-name {
        display: none;
      }
      .el-submenu__icon-arrow {
        display: none;
      }
    }

    .el-breadcrumb {
      left: 65px;
    }

    .content-wrapper {
      left: @navWidth + 5;
      .app-content {
        min-width: 1080px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?12dcfe88